import type { PopoverDOM } from 'driver.js';

const SKIP_BTN_CLASS = 'aula-tour-skip-btn';

export const ensureLiveRegion = (tourId: string): HTMLElement => {
  const regionId = `${tourId}-tour-live-region`;
  let region = document.getElementById(regionId);
  if (!region) {
    region = document.createElement('div');
    region.id = regionId;
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    Object.assign(region.style, {
      position: 'absolute',
      width: '1px',
      height: '1px',
      padding: '0',
      margin: '-1px',
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      border: '0',
    });
    document.body.appendChild(region);
  }
  return region;
};

export const announceStep = (
  tourId: string,
  title: string,
  stepIndex: number,
  totalSteps: number
): void => {
  const region = ensureLiveRegion(tourId);
  region.textContent = `${tourId} tour step ${
    stepIndex + 1
  } of ${totalSteps}: ${title}`;
};

export const attachSkipTourButton = (
  popover: PopoverDOM,
  skipText: string,
  onSkip: () => void
): void => {
  popover.closeButton.setAttribute('aria-label', skipText);
  popover.closeButton.title = skipText;

  if (popover.footer.querySelector(`.${SKIP_BTN_CLASS}`)) {
    return;
  }

  const skipBtn = document.createElement('button');
  skipBtn.type = 'button';
  skipBtn.className = `driver-popover-footer-btn ${SKIP_BTN_CLASS}`;
  skipBtn.textContent = skipText;
  skipBtn.setAttribute('aria-label', skipText);
  skipBtn.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSkip();
  });
  popover.footer.insertBefore(skipBtn, popover.footer.firstChild);
};
